import {
  CATALOGUE_ROUTE,
  EMPLOYEES_ROUTE,
  EVALUATION_LIST_ROUTE,
  EXTERNAL_ACTUAL_LIST_ROUTE,
  EXTERNAL_HISTORY_LIST_ROUTE,
  QUESTIONNAIRE_ROUTE,
  RouteWithIndex,
  SELF_ACTUAL_ROUTE,
  SELF_HISTORY_LIST_ROUTE
} from '../router/routes';
import { translation } from '../i18n';
import { EmployeeDto, Roles } from '../pages/user/userTypes';
import { hasMinRole, isAdmin } from '../security/permissions';

export enum MenuType {
  HEADER = 'HEADER',
  ITEM = 'ITEM',
  DIVIDER = 'DIVIDER'
}

export enum MenuIcons {
  PEOPLE = 'PEOPLE',
  BALLOT = 'BALLOT',
  LIST = 'LIST',
  ASSESSMENT = 'ASSESSMENT'
}

export class MenuItem {
  public type: MenuType;
  public routeWithIndex?: RouteWithIndex;
  public text?: string;
  public icon?: MenuIcons;

  constructor(type: MenuType, text?: string, routeWithIndex?: RouteWithIndex, icon?: MenuIcons) {
    this.type = type;
    this.routeWithIndex = routeWithIndex;
    this.text = text;
    this.icon = icon;
  }
}

export function MenuList(employee: EmployeeDto) {
  let menuList = publicMenuList();
  if (hasMinRole(Roles.MAINTAINER, employee)) {
    menuList = menuList.concat(maintainerMenuList())
  }
  if (isAdmin(employee)) {
    menuList = menuList.concat(adminMenuList())
  } else {
    menuList = menuList.concat(new MenuItem(MenuType.DIVIDER),)
  }

  return menuList;
}

function publicMenuList(): MenuItem[] {
  return [
    new MenuItem(MenuType.HEADER, translation.t('menu.assessment.self')),
    new MenuItem(MenuType.ITEM, translation.t('menu.assessment.actual'), SELF_ACTUAL_ROUTE),
    new MenuItem(MenuType.ITEM, translation.t('menu.assessment.history'), SELF_HISTORY_LIST_ROUTE),
    new MenuItem(MenuType.DIVIDER),

    new MenuItem(MenuType.HEADER, translation.t('menu.assessment.external')),
    new MenuItem(MenuType.ITEM, translation.t('menu.assessment.actual'), EXTERNAL_ACTUAL_LIST_ROUTE),
    new MenuItem(MenuType.ITEM, translation.t('menu.assessment.history'), EXTERNAL_HISTORY_LIST_ROUTE),
    new MenuItem(MenuType.DIVIDER),
  ];
}

function maintainerMenuList(): MenuItem[] {
  return [
    new MenuItem(MenuType.HEADER, translation.t('menu.admin')),
    new MenuItem(MenuType.ITEM, translation.t('menu.questionnaire'), QUESTIONNAIRE_ROUTE, MenuIcons.BALLOT),
    new MenuItem(MenuType.ITEM, translation.t('menu.questionCatalogue'), CATALOGUE_ROUTE, MenuIcons.LIST),
  ];
}

function adminMenuList(): MenuItem[] {
  return [
    new MenuItem(MenuType.ITEM, translation.t('menu.employees'), EMPLOYEES_ROUTE, MenuIcons.PEOPLE),
    new MenuItem(MenuType.ITEM, translation.t('menu.evaluation'), EVALUATION_LIST_ROUTE, MenuIcons.ASSESSMENT),
    new MenuItem(MenuType.DIVIDER),
  ];
}
